/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState } from "react";
import { ErrorMessage, ImageDiv } from "../../Volunteer/Volunteer.style";
import {
  Box,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import { ThemButton } from "../../Login/Login.style";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { ImageDivText } from "../../style/Table.style";
import { PhotoCamera, Visibility, VisibilityOff } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useQuery } from "@tanstack/react-query";
import { toast, ToastContainer, Zoom } from "react-toastify";
import useProfile from "../../../hooks/useProfile";
import "react-toastify/dist/ReactToastify.css";
function UserEdit({ setOpen, setMessage, setType }) {
  const dispatch = useDispatch();
  const [selectedImage, setSelectedImage] = useState();
  const [isLoading, setIsLoading] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [userData] = useProfile();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const userData1 = useSelector((state) => state.Modal.val);

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage();
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const { data: UserLevelInfo = [],refetch } = useQuery({
    queryKey: ["UserLevelInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/levelDropdown/${userData?.id}`
      );
      const data = await res.json();
      return data;
    },
  });

  const onSubmit = (data) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("id", parseInt(data.id));
    formData.append("user_image", selectedImage);
    formData.append("full_name", data.full_name);
    formData.append("username", data.username);
    formData.append("email_address", data.email_address);
    formData.append("password", data.password);
    formData.append("active_fg", data.active_fg);
    formData.append("userlvl_id", data.userlvl_id);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/updateUser`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Success Notification !", {
            position: toast.POSITION.TOP_CENTER
          });
          refetch().then(() => {
            dispatch(handleEditClose());
          });
          dispatch(handleEditClose());
        } else if (data.userDuplicate === true) {
          toast.error("This User is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (data.emailDuplicate === true) {
          toast.error("This Email is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <ImageDivText
          style={{ padding: "6px 0px 0px 12px", marginBottom: ".75rem" }}
        >
          User image (Upload)
        </ImageDivText>
        <ImageDiv
          style={{
            height: "160px",
          }}
        >
          {!selectedImage && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
                gap: ".2rem",
              }}
            >
              <div
                style={{
                  alignItem: "center",
                  justifyContent: "center",
                  marginTop: "1.5rem",
                }}
              >
                <Tooltip title="Upload image here">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={imageChange}
                    />
                    <PhotoCamera />
                  </IconButton>
                </Tooltip>
              </div>

              <div
                style={
                  userData1.user_image
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <img
                  style={{
                    height: "120px",
                    maxWidth: "200px",
                  }}
                  src={userData1.user_image}
                  alt=""
                />
              </div>
            </div>
          )}

          {selectedImage && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 4fr 1fr",
                gap: ".2rem",
              }}
            >
              <div
                style={{
                  alignItem: "center",
                  justifyContent: "center",
                  marginTop: "1.5rem",
                }}
              >
                <Tooltip title="Upload image here">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={imageChange}
                    />
                    <PhotoCamera />
                  </IconButton>
                </Tooltip>
              </div>

              <div style={{}}>
                <img
                  style={{
                    height: "120px",
                    maxWidth: "200px",
                  }}
                  src={URL.createObjectURL(selectedImage)}
                  alt="Thumb"
                />
              </div>
              <div
                style={{
                  alignItem: "center",
                  justifyContent: "center",
                  marginTop: "1.5rem",
                }}
              >
                <Tooltip title="Remove this image here">
                  <IconButton onClick={removeSelectedImage}>
                    <HighlightOffIcon
                      sx={{
                        color: "#3490DC",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          )}
        </ImageDiv>

        <Box mb="15px" sx={{ display: "none" }}>
          <TextField
            size="small"
            fullWidth
            label="ID*"
            variant="outlined"
            value={userData1.id}
            {...register("id", { required: true })}
          />
        </Box>
        <Box mb="15px" mt="15px">
          <TextField
            size="small"
            fullWidth
            label="Name*"
            variant="outlined"
            defaultValue={userData1.full_name}
            {...register("full_name", { required: true })}
          />
          {errors?.full_name?.type === "required" && (
            <ErrorMessage>Name is required*</ErrorMessage>
          )}
        </Box>
        <Box mb="15px">
          <TextField
            size="small"
            fullWidth
            label="User Name*"
            variant="outlined"
            defaultValue={userData1.username}
            {...register("username", { required: true })}
          />
          {errors?.username?.type === "required" && (
            <ErrorMessage>User Name is required*</ErrorMessage>
          )}
        </Box>

        <Box mb="15px">
          <TextField
            size="small"
            fullWidth
            label="E-mail*"
            variant="outlined"
            defaultValue={userData1.email_address}
            {...register("email_address", {
              required: true,
              pattern:
                /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            })}
          />
          {errors?.email_address?.type === "required" && (
            <ErrorMessage>E-mail is required*</ErrorMessage>
          )}
          {errors?.email_address?.type === "pattern" && (
            <ErrorMessage>E-mail is invalid</ErrorMessage>
          )}
        </Box>

        <Box mb="15px">
          <TextField
            fullWidth
            size="small"
            type={showPassword ? "text" : "password"}
            label="Password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword}>
                    {showPassword ? (
                      <Visibility fontSize="small" />
                    ) : (
                      <VisibilityOff fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            defaultValue={userData1.password}
            {...register("password", { minLength: 6, pattern: /^\S*$/ })}
          />
          {errors?.password?.type === "required" && (
            <ErrorMessage>Password is required*</ErrorMessage>
          )}
          {errors?.password?.type === "minLength" && (
            <ErrorMessage>Minimum 6 digit required</ErrorMessage>
          )}
          {errors?.password?.type === "pattern" && (
            <ErrorMessage>Space not Allowed!</ErrorMessage>
          )}
        </Box>

        <Box mb="15px">
          <TextField
            select
            fullWidth
            defaultValue={userData1.active_fg}
            name="active_fg"
            size="small"
            label="Active Status*"
            {...register("active_fg", { required: true })}
          >
            <MenuItem value={1}> Active </MenuItem>
            <MenuItem value={0}> Inactive </MenuItem>
          </TextField>
          {errors?.active_fg?.type === "required" && (
            <ErrorMessage>Active Status required*</ErrorMessage>
          )}
        </Box>

        <Box>
          <Controller
            name="userlvl_id"
            control={control}
            // defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                id="outlined-select-currency"
                select
                label="User Level*"
                defaultValue={userData1.userlvl_id}
                {...register("userlvl_id", {
                  required: true,
                })}
              >
                {UserLevelInfo.map((userLevel) => (
                  <MenuItem
                    key={userLevel.ug_level_id}
                    value={userLevel.ug_level_id}
                  >
                    {userLevel?.ugleve_name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
          {errors?.userlvl_id?.type === "required" && (
            <ErrorMessage>User Level is required</ErrorMessage>
          )}
        </Box>
      </Box>
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        <ThemButton type="submit">Update User</ThemButton>
      </Box>

      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />
    </form>
  );
}

export default UserEdit;
